import { subDays, addDays } from "date-fns";
import { nodes, dropDownTypeLabels } from "@constants/filters";

/********** ACTION_TYPES **********/
export const actionTypes = {
  updateModeWiseIncentiveFilter: "modeWiseIncentiveFilter/UPDATE",
  updateDailyIncentiveFilter: "dailyIncentiveFilter/UPDATE",
  updateMerchantIncentiveFilter: "merchantIncentiveFilter/UPDATE",
  updateInvoicesFilter: "invoicesFilter/UPDATE",
  resetFilter: "RESET_FILTER",
};

/********** REDUCER **********/
const initialState = {
  [nodes.modeWiseIncentives]: {
    dateFrom: subDays(new Date(), 6),
    dateTo: new Date(),
    pageSize: 10,
    pageOffset: 0,
    orderBy: "txnCount",
    order: "asc",
    groupBy: "payment_mode",
    staticRanges: [
      {
        label: "Yesterday",
        range: () => ({
          startDate: subDays(new Date(), 1),
          endDate: subDays(new Date(), 1),
          label: "Yesterday",
        }),
      },
      {
        label: "Past 7 days",
        range: () => ({
          startDate: subDays(new Date(), 6),
          endDate: new Date(),
          label: "Past 7 days",
        }),
      },
      {
        label: "Past 30 days",
        range: () => ({
          startDate: subDays(new Date(), 29),
          endDate: new Date(),
          label: "Past 30 days",
        }),
      },
      {
        label: "Custom Range",
        range: () => ({
          startDate: addDays(new Date(),1),
          endDate: addDays(new Date(),1),
          label: "Custom Range",
          type: "custom"
        }),
      },
    ]
  },
  [nodes.dailyIncentives]: {
    dateFrom: subDays(new Date(), 6),
    dateTo: new Date(),
    pageSize: 10,
    pageOffset: 0,
    orderBy: "date",
    order: "desc",
    staticRanges: [
      {
        label: "Yesterday",
        range: () => ({
          startDate: subDays(new Date(), 1),
          endDate: subDays(new Date(), 1),
          label: "Yesterday",
        }),
      },
      {
        label: "Past 7 days",
        range: () => ({
          startDate: subDays(new Date(), 6),
          endDate: new Date(),
          label: "Past 7 days",
        }),
      },
      {
        label: "Past 30 days",
        range: () => ({
          startDate: subDays(new Date(), 29),
          endDate: new Date(),
          label: "Past 30 days",
        }),
      },
      {
        label: "Custom Range",
        range: () => ({
          startDate: addDays(new Date(),1),
          endDate: addDays(new Date(),1),
          label: "Custom Range",
          type: "custom"
        }),
      },
    ]
  },
  [nodes.merchantIncentives]: {
    dateFrom: subDays(new Date(), 6),
    dateTo: new Date(),
    pageSize: 10,
    pageOffset: 0,
    orderBy: "merchantName",
    order: "asc",
    staticRanges: [
      {
        label: "Yesterday",
        range: () => ({
          startDate: subDays(new Date(), 1),
          endDate: subDays(new Date(), 1),
          label: "Yesterday",
        }),
      },
      {
        label: "Past 7 days",
        range: () => ({
          startDate: subDays(new Date(), 6),
          endDate: new Date(),
          label: "Past 7 days",
        }),
      },
      {
        label: "Past 30 days",
        range: () => ({
          startDate: subDays(new Date(), 29),
          endDate: new Date(),
          label: "Past 30 days",
        }),
      },
      {
        label: "Custom Range",
        range: () => ({
          startDate: addDays(new Date(),1),
          endDate: addDays(new Date(),1),
          label: "Custom Range",
          type: "custom"
        }),
      },
    ]
  },
  [nodes.invoices]: {
    pageSize: 10,
    pageOffset: 0,
    orderBy: "period",
    order: "desc",
    status: [],
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.updateModeWiseIncentiveFilter: {
      return {
        ...state,
        [nodes.modeWiseIncentives]: {
          ...state[nodes.modeWiseIncentives],
          ...action.payload,
        },
      };
    }
    case actionTypes.updateDailyIncentiveFilter: {
      return {
        ...state,
        [nodes.dailyIncentives]: {
          ...state[nodes.dailyIncentives],
          ...action.payload,
        },
      };
    }
    case actionTypes.updateMerchantIncentiveFilter: {
      return {
        ...state,
        [nodes.merchantIncentives]: {
          ...state[nodes.merchantIncentives],
          ...action.payload,
        },
      };
    }
    case actionTypes.updateInvoicesFilter: {
      return {
        ...state,
        [nodes.invoices]: {
          ...state[nodes.invoices],
          ...action.payload,
        },
      };
    }
    case actionTypes.resetFilter: {
      const node = action.payload;
      return {
        ...state,
        [node]: initialState[node],
      };
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  getFilters: (state, node) => {
    if (node) return state.partnerApp.filters[node] || {};
    else return state.partnerApp.filters;
  },
  getDateFilter: (state, node) => {
    return {
      dateFrom: state.partnerApp.filters[node].dateFrom,
      dateTo: state.partnerApp.filters[node].dateTo,
    };
  },
  getDropdownFilterCount: (state, node) => {
    const types = Object.keys(dropDownTypeLabels);
    const filters = state.partnerApp.filters[node];
    if (filters) {
      return types.reduce(
        (acc, type) =>
          acc + (filters[type] instanceof Array ? filters[type].length : 0),
        0
      );
    } else return 0;
  },
};

/********** ACTION_CREATORS **********/
export const actions = {
  updateModeWiseIncentiveFilter: (data) => ({
    type: actionTypes.updateModeWiseIncentiveFilter,
    payload: data,
  }),
  updateDailyIncentiveFilter: (data) => ({
    type: actionTypes.updateDailyIncentiveFilter,
    payload: data,
  }),
  updateMerchantIncentiveFilter: (data) => ({
    type: actionTypes.updateMerchantIncentiveFilter,
    payload: data,
  }),
  updateInvoicesFilter: (data) => ({
    type: actionTypes.updateInvoicesFilter,
    payload: data,
  }),
  resetFilter: (data) => ({
    type: actionTypes.resetFilter,
    payload: data,
  }),
};